import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={26}
    viewBox="0 0 29 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#444697'}
      d="M9.46 5.109c.52 0 .94-.42.94-.94v-1.17c.04-.09.39-.32.95-.32h6.59c.56 0 .91.23.95.28v1.21a.94.94 0 1 0 1.88 0v-1.21c0-1.21-1.24-2.15-2.82-2.15h-6.56c-1.58 0-2.82.95-2.82 2.15v1.21c0 .53.4.94.91.94h-.02ZM25.27 5.66H4.02C2.16 5.66.65 7.17.65 9.03v13.36c0 1.86 1.51 3.37 3.37 3.37h21.25c1.86 0 3.37-1.51 3.37-3.37V9.03c0-1.86-1.51-3.37-3.37-3.37Zm-10.6 9.35c-4.12 0-8.2-1.66-12.14-4.93V9.02c0-.84.66-1.49 1.49-1.49h21.25c.82 0 1.49.67 1.49 1.49v1.1c-.69.64-3.28 2.86-7.06 4.08-1.68.53-3.38.81-5.04.81h.01ZM2.53 12.48c3.9 2.9 8 4.37 12.21 4.37 1.84 0 3.7-.29 5.53-.87 2.93-.93 5.18-2.41 6.49-3.42v9.82c0 .82-.67 1.49-1.49 1.49H4.02c-.82 0-1.49-.67-1.49-1.49v-9.9Z"
    />
    <Path
      fill={props.fill || '#444697'}
      d="M10.4 19.38h8.5a.939.939 0 1 0 0-1.88h-8.5a.939.939 0 1 0 0 1.88Z"
    />
  </Svg>
);
export default SvgComponent;
